// extracted by mini-css-extract-plugin
export default {"indicator":"cartProductsIndicator_indicator__E+L0A"};